exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".rdw-editor-main {\n  border: 1px solid #EEE;\n  border-top: 0;\n  margin-top: -6px;\n  padding: 15px; }\n  .rdw-editor-main .public-DraftStyleDefault-block {\n    margin: 0; }\n\n.rdw-fontsize-dropdown {\n  min-width: 40px; }\n\n.rdw-dropdown-selectedtext {\n  font-size: 10pt;\n  color: #000;\n  line-height: 20px; }\n\n.rdw-option-wrapper {\n  height: 30px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./src/components/Form/components/Wysiwyg/styles.scss
// module id = ../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./src/components/Form/components/Wysiwyg/styles.scss
// module chunks = 0